import React from 'react';
interface AlkmaarSkylineProps {
  className?: string;
  color?: string;
}
export function AlkmaarSkyline({
  className = '',
  color = '#BCCCDC'
}: AlkmaarSkylineProps) {
  return <svg viewBox="0 0 1200 200" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} preserveAspectRatio="xMidYMax slice" data-id="element-219">
      {/* Left buildings */}
      <rect x="50" y="120" width="40" height="80" stroke={color} strokeWidth="1.5" fill="none" data-id="element-220" />
      <rect x="55" y="130" width="10" height="15" stroke={color} strokeWidth="1" fill="none" data-id="element-221" />
      <rect x="75" y="130" width="10" height="15" stroke={color} strokeWidth="1" fill="none" data-id="element-222" />
      <rect x="55" y="155" width="10" height="15" stroke={color} strokeWidth="1" fill="none" data-id="element-223" />
      <rect x="75" y="155" width="10" height="15" stroke={color} strokeWidth="1" fill="none" data-id="element-224" />

      <rect x="100" y="100" width="50" height="100" stroke={color} strokeWidth="1.5" fill="none" data-id="element-225" />
      <path d="M100 100 L125 70 L150 100" stroke={color} strokeWidth="1.5" fill="none" data-id="element-226" />
      <rect x="115" y="160" width="20" height="40" stroke={color} strokeWidth="1" fill="none" data-id="element-227" />

      <rect x="160" y="130" width="35" height="70" stroke={color} strokeWidth="1.5" fill="none" data-id="element-228" />
      <rect x="168" y="140" width="8" height="12" stroke={color} strokeWidth="1" fill="none" data-id="element-229" />
      <rect x="180" y="140" width="8" height="12" stroke={color} strokeWidth="1" fill="none" data-id="element-230" />

      {/* Church/building left of Waag */}
      <rect x="220" y="90" width="60" height="110" stroke={color} strokeWidth="1.5" fill="none" data-id="element-231" />
      <path d="M220 90 L250 50 L280 90" stroke={color} strokeWidth="1.5" fill="none" data-id="element-232" />
      <circle cx="250" cy="70" r="8" stroke={color} strokeWidth="1" fill="none" data-id="element-233" />
      <rect x="240" y="160" width="20" height="40" stroke={color} strokeWidth="1" fill="none" data-id="element-234" />

      {/* Small buildings */}
      <rect x="290" y="140" width="30" height="60" stroke={color} strokeWidth="1.5" fill="none" data-id="element-235" />
      <rect x="330" y="125" width="40" height="75" stroke={color} strokeWidth="1.5" fill="none" data-id="element-236" />

      {/* Waagtoren (Waag Tower) - Central element */}
      <rect x="400" y="60" width="100" height="140" stroke={color} strokeWidth="2" fill="none" data-id="element-237" />
      <path d="M400 60 L450 15 L500 60" stroke={color} strokeWidth="2" fill="none" data-id="element-238" />
      <rect x="440" y="20" width="20" height="40" stroke={color} strokeWidth="1.5" fill="none" data-id="element-239" />
      <path d="M440 20 L450 5 L460 20" stroke={color} strokeWidth="1.5" fill="none" data-id="element-240" />

      {/* Waag windows */}
      <rect x="415" y="80" width="25" height="35" stroke={color} strokeWidth="1.5" fill="none" data-id="element-241" />
      <rect x="460" y="80" width="25" height="35" stroke={color} strokeWidth="1.5" fill="none" data-id="element-242" />
      <rect x="415" y="130" width="25" height="35" stroke={color} strokeWidth="1.5" fill="none" data-id="element-243" />
      <rect x="460" y="130" width="25" height="35" stroke={color} strokeWidth="1.5" fill="none" data-id="element-244" />

      {/* Waag door */}
      <path d="M435 200 L435 175 Q450 165 465 175 L465 200" stroke={color} strokeWidth="1.5" fill="none" data-id="element-245" />

      {/* Clock on Waag */}
      <circle cx="450" cy="55" r="12" stroke={color} strokeWidth="1.5" fill="none" data-id="element-246" />
      <line x1="450" y1="55" x2="450" y2="47" stroke={color} strokeWidth="1" data-id="element-247" />
      <line x1="450" y1="55" x2="456" y2="55" stroke={color} strokeWidth="1" data-id="element-248" />

      {/* Buildings right of Waag */}
      <rect x="520" y="110" width="45" height="90" stroke={color} strokeWidth="1.5" fill="none" data-id="element-249" />
      <path d="M520 110 L542 85 L565 110" stroke={color} strokeWidth="1.5" fill="none" data-id="element-250" />

      <rect x="575" y="130" width="35" height="70" stroke={color} strokeWidth="1.5" fill="none" data-id="element-251" />
      <rect x="583" y="140" width="8" height="12" stroke={color} strokeWidth="1" fill="none" data-id="element-252" />
      <rect x="595" y="140" width="8" height="12" stroke={color} strokeWidth="1" fill="none" data-id="element-253" />

      <rect x="620" y="100" width="50" height="100" stroke={color} strokeWidth="1.5" fill="none" data-id="element-254" />
      <rect x="635" y="115" width="20" height="25" stroke={color} strokeWidth="1" fill="none" data-id="element-255" />
      <rect x="635" y="150" width="20" height="25" stroke={color} strokeWidth="1" fill="none" data-id="element-256" />

      {/* Church on right */}
      <rect x="690" y="80" width="55" height="120" stroke={color} strokeWidth="1.5" fill="none" data-id="element-257" />
      <path d="M690 80 L717 40 L745 80" stroke={color} strokeWidth="1.5" fill="none" data-id="element-258" />
      <line x1="717" y1="40" x2="717" y2="25" stroke={color} strokeWidth="1.5" data-id="element-259" />
      <line x1="710" y1="30" x2="724" y2="30" stroke={color} strokeWidth="1.5" data-id="element-260" />
      <rect x="705" y="160" width="24" height="40" stroke={color} strokeWidth="1" fill="none" data-id="element-261" />

      {/* More buildings on far right */}
      <rect x="760" y="120" width="40" height="80" stroke={color} strokeWidth="1.5" fill="none" data-id="element-262" />
      <rect x="810" y="135" width="35" height="65" stroke={color} strokeWidth="1.5" fill="none" data-id="element-263" />
      <rect x="855" y="145" width="45" height="55" stroke={color} strokeWidth="1.5" fill="none" data-id="element-264" />

      {/* Ground line */}
      <line x1="0" y1="200" x2="1200" y2="200" stroke={color} strokeWidth="1" data-id="element-265" />
    </svg>;
}